<template>
	<section class="content-wrapper">
		<router-link to="/" exact class="btn btn-back">
			<img
				src="images/chevron-left-green.svg"
				style="margin-right: 6px"
			/>powrót
		</router-link>

		<h1>PIT</h1>
		<div class="text-container">
			<p v-html="pitStatement.staticText"></p>

			<section v-if="pitStatement.isPitAccepted">
				<span v-for="file in pitFiles" :key="file.data">
					<a :href="file.url" :download="file.fileName">{{
						file.fileName
					}}</a>
					<br />
				</span>
				<br />
				<button @click="cancelDeclaration" class="btn btn-secondary">
					Rezygnuję z PIT-a w wersji elektronicznej
				</button>
			</section>
			<section v-else>
				<p style="margin-bottom: 30px">
					<strong>
						Chcę otrzymywać PIT 8C w wersji elektronicznej.
						Akceptuję Oświadczenie PIT elektroniczny
					</strong>
				</p>

				<button @click="acceptDeclaration" class="btn btn-primary">
					Akceptuję oświadczenie
				</button>
			</section>
		</div>
		<br />
		<router-link
			to="/"
			v-if="windowWidth < mobileBreakpoint"
			exact
			class="btn btn-secondary"
			>Powrót</router-link
		>
		<br />
		<br />
	</section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		pitStatement() {
			return this.$store.getters.getPitStatement
				? this.$store.getters.getPitStatement
				: false;
		},
		pitFiles() {
			if (
				this.$store.getters.getPitFiles &&
				this.$store.getters.getPitFiles.length
			) {
				let sortedPitFiles = this.$store.getters.getPitFiles;
				sortedPitFiles.sort(function (a, b) {
					if (a.fileName > b.fileName) return -1;
					if (b.fileName > a.fileName) return 1;
				});
				return sortedPitFiles;
			} else {
				return [];
			}
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		...mapGetters({ mobileBreakpoint: 'getMobileBreakpoing' }),
	},
	methods: {
		acceptDeclaration() {
			this.$store.dispatch('postAcceptDeclaration');
		},
		cancelDeclaration() {
			this.$store.dispatch('postCancelDeclaration');
		},
	},
	beforeMount() {
		this.$store.dispatch('fetchPitStatement');
		this.$store.dispatch(
			'fetchLogOutTimer',
			this.$store.getters.getTimeToLogout
		);
	},
};
</script>
